import api from './api'
import { setErrors } from 'utils'

export const handleChatbotShow = async id => (await api.get(`/chats/${id}`)).data

export const handleChatbotStore = async (history, data, setMessages) => {
  try {
    const response = await api.post(`/chatbots/store`, data)
    return history.push(`/chatbots/${response.data.id}/update`)
  } catch (error) {
    setMessages({ messages: setErrors(error), alert: 'alert-orange' })
  }
}